import { forwardRef, type Ref } from 'react';
import clsx from 'clsx';
import { useExperiment } from '@hungryroot/experiments';
import { OpenBoxNew } from '@hungryroot/icons';
import { CalloutBox } from '@hungryroot/pho';
import { Paragraph } from '@hungryroot/ramen';

import styles from './CalloutBoxSelector.module.css';
export const CALLOUT_BOX_COPY = `After checkout, see what we’ve picked just for you. Add, swap, or remove items — pay only for what you want.`;
export const CALLOUT_BOX_TEST_ID = 'pay-as-you-go-callout-box';

export const CalloutBoxSelector = forwardRef(
  (props: { className?: string }, ref: Ref<HTMLDivElement>) => {
    const { className } = props;
    const payAsYouGoVariant = useExperiment(173);

    const isPayAsYouGoVariant =
      payAsYouGoVariant !== undefined && payAsYouGoVariant > 0;

    const isLoadingCalloutBox = payAsYouGoVariant === undefined;

    if (isLoadingCalloutBox || !isPayAsYouGoVariant) {
      return null;
    }

    return (
      <CalloutBox
        ref={ref}
        className={clsx(styles.box, className)}
        testid={CALLOUT_BOX_TEST_ID}
        image={
          <div data-testid="open-box-svg" className={styles['open-box']}>
            <OpenBoxNew />
          </div>
        }
      >
        <Paragraph className={styles.callout}>{CALLOUT_BOX_COPY}</Paragraph>
      </CalloutBox>
    );
  }
);
